<template>
    <router-link class="app-nav-user" to="/controlPanel/profile" :aria-label="'Perfil de ' + name"
        :title="mini ? name : null">
        <img class="app-nav-user__avatar" :src="avatarUrl" alt="" />
        <span v-if="!mini" class="app-nav-user__text">
            <span class="app-nav-user__name">{{ name }}</span>
            <span class="app-nav-user__role">{{ role }}</span>
        </span>
    </router-link>
</template>
<script>
import { roleLabel } from '@/service/permiso/menuModel';

/** Usuario en el pie del drawer: enlaza al perfil. */
export default {
    name: 'AppNavUser',
    props: {
        user: { type: Object, default: () => ({}) },
        avatarUrl: { type: String, default: '' },
        mini: { type: Boolean, default: false }
    },
    computed: {
        name() {
            return this.user.username || this.user.nombre || '';
        },
        role() {
            return roleLabel(this.user.roleName);
        }
    }
};
</script>
<style scoped>
.app-nav-user {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-top: 1px solid var(--app-line);
    color: var(--app-text);
    text-decoration: none;
}
.app-nav-user:hover {
    background: var(--app-nav-hover);
}
.app-nav-user:focus-visible {
    outline: 2px solid var(--app-primary);
    outline-offset: -2px;
}
.app-nav-user__avatar {
    flex: 0 0 32px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    background: var(--app-surface);
}
.app-nav-user__text {
    display: flex;
    flex-direction: column;
    min-width: 0;
    line-height: 1.25;
}
.app-nav-user__name,
.app-nav-user__role {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.app-nav-user__name {
    font-size: 14px;
    font-weight: 600;
}
.app-nav-user__role {
    font-size: 12px;
    color: var(--app-text-muted);
}
</style>
